import React from 'react';
import { withRouter } from '../../utils/router';
import superagent from "superagent";
import CustomMenu from "./CustomMenu";
import { Divider, Button, notification } from 'antd';
import { BACKEND_API_URL, APP_NAME, ERROR_CODE } from '../../utils/constants'
import { getDateTime } from "../../utils/utils";
import { generateEncryptionKey, } from "../../data/encryption";
import { compressData } from "../../data/encode";
import { serializeAsJSON } from "../../data/json";
import {
    FolderOutlined, SnippetsOutlined, ApartmentOutlined,
    BranchesOutlined, ClusterOutlined, CalculatorOutlined, CloudServerOutlined,
    GroupOutlined, HddOutlined, AppstoreAddOutlined, PicCenterOutlined, BgColorsOutlined, ExperimentOutlined
} from '@ant-design/icons';

const menus = [
    {
        title: '我的设计',
        icon: <FolderOutlined />,
        key: '/manage/design',
        subs: [
            // { key: '/manage/design/flowchart', title: '流程图', icon: <ApartmentOutlined />, },
            // { key: '/manage/design/mindmap', title: '思维导图', icon: <BranchesOutlined />, },
            { key: '/manage/design/whiteboard', title: '在线白板', icon: <CalculatorOutlined />, },
            // { key: '/manage/design/sysarc', title: '系统架构', icon: <CloudServerOutlined />, },
            // { key: '/manage/design/orgarc', title: '组织管理', icon: <ClusterOutlined />, },
            // { key: '/manage/design/other', title: '其他效果', icon: <PicCenterOutlined />, },
        ]
    },
    {
        title: '我的模板',
        icon: <SnippetsOutlined />,
        key: '/manage/template',
        subs: [
            { key: '/manage/template/created', title: '创建的模板', icon: <GroupOutlined />, },
            // { key: '/manage/template/favorite', title: '喜欢的模板', icon: <HddOutlined />, },
        ]
    },
    {
        title: '我的素材',
        icon: <ExperimentOutlined />,
        key: '/manage/library',
        subs: [
            { key: '/manage/library/created', title: '创建的素材', icon: <BgColorsOutlined />, },
            // { key: '/manage/template/favorite', title: '喜欢的模板', icon: <HddOutlined />, },
        ]
    }
]

class SiderNav extends React.Component {
    goBackHome = () => {
        this.props.router.navigate('/')
    }

    async createDraw() {
        let self = this
        function callback(error, response) {
            if (!error && (response.statusCode === 401 || response.statusCode === 403)) {
                notification["error"]({ message: '创建设计失败', description: '系统错误', });
            } else if (!error && response.statusCode === 200) {
                const jsonRes = JSON.parse(response.text);
                if (jsonRes.code === 0) {
                    window.open(window.location.origin + "/draw?id=" + jsonRes.info, APP_NAME);
                } else if (jsonRes.code === ERROR_CODE.NOT_AUTHORIZED) {
                    notification["error"]({ message: '用户未登录，请先登录', description: jsonRes.info, });
                    logout();
                    self.props.router.navigate('/login');
                } else {
                    notification["error"]({ message: '创建设计失败', description: jsonRes.info, });
                }
            } else {
                notification["error"]({ message: '创建设计失败', description: '网络错误', });
            }
        }

        const encryptionKey = await generateEncryptionKey("string");
        const payload = await compressData(
            new TextEncoder().encode(
                serializeAsJSON([], {}, {}, "database"),
            ),
            { encryptionKey },
        );
        superagent.post(BACKEND_API_URL.DESIGN_CREATE_URL)
            .send({
                category: "白板",
                title: `Untitled-${getDateTime()}`,
                encryptionKey: encryptionKey,
                content: payload.toString(),
            })
            .withCredentials()
            .set('Accept', 'application/json')
            .end(callback);
    }

    render() {
        const { collapsed, theme } = this.props
        let createBtn = collapsed ? (
            <AppstoreAddOutlined style={{ fontSize: '20px', color: '#08c' }} onClick={() => { this.createDraw(); }} />
        ) : (
            <Button type='primary'
                icon={<AppstoreAddOutlined />}
                style={styles.create_button}
                onClick={() => { this.createDraw(); }}>
                新建文件
            </Button >
        )

        let logoBtn = collapsed ? (
            <div style={styles.logo} onClick={() => this.props.router.navigate('/')}>
                <img style={styles.icon} src={'/logo.png'} alt="" />
            </div>
        ) : (
            <div style={styles.logo} onClick={() => this.props.router.navigate('/')}>
                <img style={styles.img} src={'/logo.png'} alt="" />
                <span style={styles.text}>元纹</span>
                <span style={styles.word}>免费</span>
            </div>
        )
        return (
            <div style={{ height: '100%', borderRight: '1px #eee solid', overflowY: 'scroll' }}>
                {logoBtn}
                <Divider />
                <div style={styles.create_inline}>
                    <div style={styles.create_box}>
                        {createBtn}
                    </div>
                </div>
                <CustomMenu menus={menus} theme={theme} />
            </div >
        )
    }
}

const styles = {
    logo: {
        height: '54px',
        width: '200px',
        flexGrow: '0',
        padding: '5px',
        fontWeight: 'bolder',
        fontSize: 'large',
        textAlign: 'left',
        cursor: 'pointer',
        float: 'left',
    },
    img: {
        margin: '0 5px 0 5px',
        height: '45px',
        width: '45px',
    },
    text: {
        fontSize: '25px',
        color: '#55cd53',
        lineHeight: '45px',
        verticalAlign: 'top',
    },
    icon: {
        margin: '3px',
        height: '45px',
        width: '45px',
        display: 'table-cell',
    },
    word: {
        fontSize: '20px',
        fontFamily: 'cursive',
        float: 'right',
        lineHeight: '75px',
        verticalAlign: 'bottom',
        color: '#888',
    },

    create_inline: {
        textAlign: 'center',
        position: 'relative',
        height: '40px',
        padding: '3px 0',
    },

    create_box: {
        display: 'inline-block',
        margin: 'auto auto 0px',
        position: 'relative',
        textAlign: 'center',
    },

    create_button: {
        width: '150px',
    }

}

export default withRouter(SiderNav)